import Vue from 'vue'

import NC from '@/lib/notification-center'

import Project from '@/components/project'
import Modal from '@/components/modal'
import Experiment from '@/components/experiment'

import utils from '@/lib/utils'

import defaultScroll from '@/mixins/default_scroll'

import logo from '@/assets/svg/logo.svg'

export default  {
  name: 'home',
  mixins: [defaultScroll],
  props: [],
  data() {
    return {
      logo: '',
      updateKey: 0
    }
  },

  components: {
    project: Project,
    modal: Modal,
    experiment: Experiment
  },

  mounted() {
    Vue.nextTick(this._nextTick.bind(this));

    NC.on('modal:opened', this._onModalOpened);
    NC.on('modal:closed', this._onModalClosed);

    this.$data.logo = logo;
  },

  methods: {

    _nextTick() {
      setTimeout(() => {
        this.initScroll();
      }, 300)

      const nowId = utils.getStorageId();
      const lastStorage = utils.getLastStorageId();
      if (lastStorage !== nowId) {
        localStorage.clear();
        this.updateKey = 1;
      }
    },

    _onModalOpened() {
      (typeof this.scroll!== 'undefined') && this.scroll.pause();
    },

    _onModalClosed() {
      (typeof this.scroll!== 'undefined') && this.scroll.play();
    }
    
  }
}




// WEBPACK FOOTER //
// ./src/components/home/home.component.js